import { Component, Output, EventEmitter, Inject } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-comments',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './view-comments.component.html',
  styleUrl: './view-comments.component.scss',
})
export class ViewCommentsComponent {
  @Output() addComments = new EventEmitter<void>(); // triggers opening add dialog
  @Output() close = new EventEmitter<void>(); // closes dialog

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { record: any },
    private dialogRef: MatDialogRef<ViewCommentsComponent>,
  ) {}

  onAddComments(): void {
    this.addComments.emit();
  }

  onClose(): void {
    this.close.emit();
    this.dialogRef.close();
  }
}
